import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Form from 'flarum/common/components/Form';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';
import ItemList from 'flarum/common/utils/ItemList';
import haptic from 'flarum/common/utils/haptic';
export default class FlagPostModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.success = false;
    this.reason = Stream('');
    this.reasonDetail = Stream('');
  }
  className() {
    return 'FlagPostModal Modal--medium';
  }
  title() {
    return app.translator.trans('flarum-flags.forum.flag_post.title');
  }
  content() {
    if (this.success) {
      return m("div", {
        className: "Modal-body"
      }, m(Form, {
        className: "Form--centered"
      }, m("p", {
        className: "helpText"
      }, app.translator.trans('flarum-flags.forum.flag_post.confirmation_message')), m("div", {
        className: "Form-group Form-controls"
      }, m(Button, {
        className: "Button Button--primary Button--block",
        onclick: this.hide.bind(this)
      }, app.translator.trans('flarum-flags.forum.flag_post.dismiss_button')))));
    }
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m("div", null, this.flagReasons().toArray())), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading,
      disabled: !this.reason()
    }, app.translator.trans('flarum-flags.forum.flag_post.submit_button')))));
  }
  flagReasons() {
    const items = new ItemList();
    const guidelinesUrl = app.forum.attribute('guidelinesUrl');
    items.add('off-topic', m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "reason",
      checked: this.reason() === 'off_topic',
      value: "off_topic",
      onclick: withAttr('value', this.reason)
    }), m("strong", null, app.translator.trans('flarum-flags.forum.flag_post.reason_off_topic_label')), app.translator.trans('flarum-flags.forum.flag_post.reason_off_topic_text'), this.reason() === 'off_topic' && m("textarea", {
      className: "FormControl",
      placeholder: app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder'),
      value: this.reasonDetail(),
      oninput: withAttr('value', this.reasonDetail)
    })), 70);
    items.add('inappropriate', m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "reason",
      checked: this.reason() === 'inappropriate',
      value: "inappropriate",
      onclick: withAttr('value', this.reason)
    }), m("strong", null, app.translator.trans('flarum-flags.forum.flag_post.reason_inappropriate_label')), app.translator.trans('flarum-flags.forum.flag_post.reason_inappropriate_text', {
      a: guidelinesUrl ? m("a", {
        href: guidelinesUrl,
        target: "_blank"
      }) : undefined
    }), this.reason() === 'inappropriate' && m("textarea", {
      className: "FormControl",
      placeholder: app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder'),
      value: this.reasonDetail(),
      oninput: withAttr('value', this.reasonDetail)
    })), 60);
    items.add('spam', m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "reason",
      checked: this.reason() === 'spam',
      value: "spam",
      onclick: withAttr('value', this.reason)
    }), m("strong", null, app.translator.trans('flarum-flags.forum.flag_post.reason_spam_label')), app.translator.trans('flarum-flags.forum.flag_post.reason_spam_text'), this.reason() === 'spam' && m("textarea", {
      className: "FormControl",
      placeholder: app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder'),
      value: this.reasonDetail(),
      oninput: withAttr('value', this.reasonDetail)
    })), 50);
    items.add('other', m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "reason",
      checked: this.reason() === 'other',
      value: "other",
      onclick: withAttr('value', this.reason)
    }), m("strong", null, app.translator.trans('flarum-flags.forum.flag_post.reason_other_label')), this.reason() === 'other' && m("textarea", {
      className: "FormControl",
      value: this.reasonDetail(),
      oninput: withAttr('value', this.reasonDetail)
    })), 10);
    return items;
  }
  onsubmit(e) {
    e.preventDefault();
    haptic('warning');
    this.loading = true;
    app.store.createRecord('flags').save({
      reason: this.reason() === 'other' ? null : this.reason(),
      reasonDetail: this.reasonDetail(),
      relationships: {
        post: this.attrs.post
      }
    }, {
      errorHandler: this.onerror.bind(this)
    }).then(() => {
      this.success = true;
    }).catch(() => {}).then(this.loaded.bind(this));
  }
}
flarum.reg.add('flarum-flags', 'forum/components/FlagPostModal', FlagPostModal);